// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3AJ4E","colMin":"styles_colMin__35vqx"};